import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function ReviewsTab() {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/admin/price-reviews").then((r) => setReviews(r.data));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try {
      await api.post(`/admin/price-reviews/${id}/${action}`);
      toast.success(action === "approve" ? "New cost approved & price updated" : "Change rejected");
      load();
    } catch { toast.error("Action failed"); }
  };

  return (
    <div>
      <h1 className="text-3xl font-extrabold mb-1">Price Reviews</h1>
      <p className="text-muted-foreground mb-6">Suspicious supplier cost changes are held here before affecting customer pricing.</p>
      <div className="space-y-3">
        {reviews.length === 0 && <div className="rounded-xl border bg-white p-8 text-center text-muted-foreground">No pending price reviews. All supplier costs look normal.</div>}
        {reviews.map((r) => (
          <div key={r.id} data-testid={`review-${r.sku}`} className="rounded-xl border bg-white p-5 flex flex-wrap items-center gap-4">
            <AlertTriangle className="text-destructive shrink-0" />
            <div className="flex-1 min-w-[200px]">
              <div className="font-semibold">{r.product_name} <span className="font-mono text-xs text-muted-foreground">({r.sku})</span></div>
              <div className="text-sm text-destructive">{r.reason}</div>
              <div className="text-sm mt-1">Cost: <span className="font-mono line-through text-muted-foreground">{money(r.old_cost)}</span> → <span className="font-mono font-bold">{money(r.new_cost)}</span></div>
            </div>
            <div className="flex gap-2">
              <Button data-testid={`approve-${r.sku}`} onClick={() => act(r.id, "approve")} className="bg-emerald-600 hover:bg-emerald-700">Approve</Button>
              <Button data-testid={`reject-${r.sku}`} onClick={() => act(r.id, "reject")} variant="outline">Reject</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
